import { helper } from '@ember/component/helper';

import { gte } from 'rise-ui/utils/choice.js';

export default helper(function gteHelper(params) {
  return gte(...params);
});
